import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=42531f5b&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=42531f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42531f5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42531f5b')) {
      api.createRecord('42531f5b', component.options)
    } else {
      api.reload('42531f5b', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=42531f5b&scoped=true&", function () {
      api.rerender('42531f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Customer/Edit.vue"
export default component.exports